import React, { useState, useEffect } from "react";
import { message } from "antd";
import axios from "axios";
import moment from "moment";

import {
  FaTrash,
  FaStar,
  FaMoon,
  FaPlaneArrival,
  FaPlaneDeparture,
  FaThermometer,
  FaSun,
  FaEdit,
  FaUmbrella,
} from "react-icons/fa";
function CoverageRoster({ onClose }) {
  const [events, setValuegetCalendar] = useState([]);
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const dayAbbreviations = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const numbers = Array.from({ length: 24 }, (_, index) => index + 1);
  const startDateObj = new Date(startDate); // Convert string to Date
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()); // Current month
  const [dataSearch, setdataSearch] = useState("");
  useEffect(() => {
    // Get the first date of the current month
    const firstDayOfMonth = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );

    // Get the last date of the current month
    const lastDayOfMonth = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );

    const currentDate = new Date(); // Get the current date
    console.log(firstDayOfMonth, lastDayOfMonth);
    // Set the start and end date
    setstartDate(firstDayOfMonth);
    setendDate(lastDayOfMonth);
  }, []);
  const handleEndDate = (e) => {
    const date = new Date(e.target.value);
    setSelectedYear(date.getFullYear());
    setSelectedMonth(date.getMonth() + 1);
    var endate = new Date(e.target.value);
    var formattedDate = endate.toString();
    setendDate(formattedDate);
    updateButtonState(startDate, endate);
  };
  const handlesearchInput = (e) => {
    var search = e.target.value;
    setdataSearch(search);
  };
  const handleStartDate = (e) => {
    var stdate = new Date(e.target.value);
    var formattedDate = stdate.toString();
    setstartDate(formattedDate);
    updateButtonState(stdate, endDate);
  };
  const updateButtonState = (start, end) => {
    // Enable the button only when both dates are selected and endDate >= startDate
    if (start && end) {
      const isValid = new Date(end) >= new Date(start); // Ensure endDate is not earlier than startDate
      setIsButtonEnabled(isValid);
    } else {
      setIsButtonEnabled(false);
    }
  };
  const endDateObj = new Date(endDate);
  const daysInRange =
    Math.ceil((endDateObj - startDateObj) / (1000 * 3600 * 24)) + 1;

  useEffect(() => {
    getCoverageRoster();
  }, [startDate, endDate]);
  const getCoverageRoster = () => {
    let formdata = {
      startDate: startDate,
      endDate: endDate,
      search: "",
    };
    console.log(formdata);
    axios
      .post("https://jlmining.app/admin/getallUserCalendardetail", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.maindata;
        const all_data = [];
        for (let i = 0; i < alldata.length; i++) {
          var cudate = new Date();
          var st_date = moment(cudate).format("YYYY-MM-DD");
          var clr = "";
          var id = alldata[i].attend_id;
          var signed = "";
          var hourstatus = alldata[i].hours_status;
          var location_id = alldata[i].location_id;
          var client_id = alldata[i].client_id;
          var rostertype = alldata[i].roster;
          var rosterId = alldata[i].rosterId;

          if (hourstatus === "Client") {
            var signed = "Signed";
          }
          if (alldata[i].id == "") {
            var title = "";
            var ic = "";
            var colr = "white";
            var pop = "Open";
            var cudate = new Date();

            var st_date = moment(cudate).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = "";
            var hours = "";
          }
          if (alldata[i].shift === "Day") {
            var title = "DS";
            var ic = <FaSun />;
            var colr = "#B2DAF2";
            var clr = "black";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "Edit") {
            var title = "Edit | " + alldata[i].client_name;
            var ic = <FaEdit />;
            var pop = "Open";
            var colr = "gray";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "Add") {
            var title = "RR";
            var ic = "";
            var pop = "Open";
            var colr = "white";
            var clr = "red";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "Night") {
            var title = "DN";
            var ic = <FaMoon />;
            var colr = "#1D0303";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "FLIAM") {
            var title = "FLIAM";
            var ic = <FaPlaneArrival />;
            var colr = "#B9723D";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "FLIPM") {
            var title = "FLIPM";
            var ic = <FaPlaneArrival />;
            var colr = "#7DBFFC";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "FLOAM") {
            var title = "FLOAM";
            var ic = <FaPlaneDeparture />;
            var colr = "#9F20AA";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "FLOPM") {
            var title = "FLOPM";
            var ic = <FaPlaneDeparture />;
            var colr = "#77D928";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "Sick Leave") {
            var title = "Sick Leave";
            var ic = <FaThermometer />;
            var colr = "#395AEF";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "AL") {
            var title = "AL";
            var ic = <FaUmbrella />;
            var colr = "#F71718";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "Work Offsite") {
            var title = "Work Offsite";
            var ic = <FaUmbrella />;
            var colr = "#490909";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "Leave Without Pay") {
            var title = "Leave Without Pay";
            var ic = "";
            var colr = "#F3DC0C";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "In Isolation on site") {
            var title = "In Isolation on site";
            var ic = <FaStar />;
            var colr = "#FB02F5";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "Work Camp") {
            var title = "Work Camp";
            var ic = <FaStar />;
            var colr = "#F8B70D";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          if (alldata[i].shift === "SC") {
            var title = "SC " + signed;
            var ic = "";
            var colr = "#0B5ED7";
            var clr = "black";
            var pop = "Close";
            var st_date = moment(alldata[i].date).format("YYYY-MM-DD");

            var start = st_date;
            var end = st_date;
            var shft = alldata[i].shift;
            var hours = alldata[i].hours;
          }
          var fn = alldata[i].first_name;
          var mn = "";
          var ln = alldata[i].last_name;
          let findata = {
            title: title,
            roster: alldata[i].roster,
            start: start,
            end: end,
            user_id: alldata[i].user_id,
            color: clr,
            backgroundColor: colr,
            text: "center",
            icon: ic,
            pop: pop,
            id: id,
            shft: shft,
            hours: hours,
            user_role: alldata[i].user_role,
            loc_name: alldata[i].loc_name,
            client_name: alldata[i].client_name,
            username: fn + " " + mn + " " + ln,
            client_id: client_id,
            location_id: location_id,
            rostertype: rostertype,
            rosterId: rosterId,
          };

          all_data.push(findata);
        }

        setValuegetCalendar(all_data);
      })
      .catch((err) => {});
  };
  const groupedData = events.reduce((acc, item) => {
    // Create a unique key for each user+roster combination
    const key = `${item.username || "Unknown"}_${item.roster || "N/A"}_${
      item.client_name || "N/A"
    }_${item.loc_name || "N/A"}`;

    if (!acc[key]) {
      acc[key] = {
        username: item.username,
        roster: item.roster,
        client_name: item.client_name,
        loc_name: item.loc_name,
        user_id: item.user_id,
        user_role: item.user_role,
        attend_id: item.attend_id,
        location_id: item.location_id,
        events: [],
      };
    }

    acc[key].events.push(item);

    return acc;
  }, {});
  console.log(groupedData);
  return (
    <>
      <div className="d-flex flex-column gap-1">
        <div className="d-flex flex-wrap align-items-center justify-content-center gap-md-4 gap-2">
          <div className="filter-item">
            <label className="filter-label" htmlFor="employee">
              Start Date
            </label>
            <input
              type="date"
              name="startDate"
              onChange={handleStartDate}
              style={{
                padding: "13px",
                margin: "5px",
              }}
            />
          </div>
          <h5>To </h5>

          <div className="filter-item">
            <label className="filter-label" htmlFor="employee">
              End Date
            </label>
            <input
              type="date"
              name="endDate"
              onChange={handleEndDate}
              style={{
                padding: "13px",
                margin: "5px",
              }}
            />
          </div>
        </div>
      </div>

      <div
        className="table-container tablecontainerStyle"
        style={{ overflowX: "auto", maxWidth: "100%" }}
      >
        <table className="styled-table tablestyled">
          <thead>
            <tr>
              <th
                style={{
                  fontSize: "12px",
                  position: "sticky",
                  left: "-1px",
                  zIndex: "98",
                }}
                className="headersticky sticky-left"
              >
                Employee Name
              </th>
              <th
                className="headersticky"
                style={{
                  fontSize: "12px",
                  position: "sticky",
                  left: "71px",
                  zIndex: "98",
                }}
              >
                Main Client
              </th>

              <th
                className="headersticky"
                style={{
                  fontSize: "12px",
                  position: "sticky",
                  left: "122px",
                  zIndex: "98",
                }}
              >
                Employee Role
              </th>
              <th
                className="headersticky"
                style={{
                  fontSize: "12px",
                  position: "sticky",
                  left: "194px",
                  zIndex: "98",
                }}
              >
                Location
              </th>
              <th
                className="headersticky sticky-right"
                style={{
                  fontSize: "12px",
                  position: "sticky",
                  left: "260px",
                  zIndex: "98",
                }}
              >
                RT
              </th>
              {Array.from({ length: daysInRange }, (_, i) => {
                // Create a new Date object for each day in the range
                const currentDay = new Date(startDateObj.getTime());
                currentDay.setDate(startDateObj.getDate() + i); // Increment day by i

                const day = currentDay.getDate();
                const weekday = currentDay.getDay();

                return (
                  <th key={i} style={{ fontSize: "12px" }}>
                    {day.toString().padStart(2, "0")}/
                    {(currentDay.getMonth() + 1).toString().padStart(2, "0")}{" "}
                    <br />
                    {dayAbbreviations[weekday]}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {Object.keys(groupedData).length === 0 ? (
              <tr>
                <td
                  colSpan={daysInRange + 5}
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                  }}
                >
                  No results found
                </td>
              </tr>
            ) : (
              Object.keys(groupedData).map((key) => {
                const userData = groupedData[key];
                const username = userData.username;

                // Skip invalid usernames
                if (
                  !username ||
                  username.trim() === "" ||
                  username === "undefined  undefined" ||
                  username === "undefined undefined undefined"
                ) {
                  return null;
                }

                return (
                  <tr key={key}>
                    <td
                      className="headersticky sticky-left"
                      style={{
                        fontSize: "12px",
                        position: "sticky",
                        left: "-1px",
                        backgroundColor: "#fff",
                        zIndex: "98",
                      }}
                    >
                      {username}
                    </td>
                    <td
                      className="headersticky"
                      style={{
                        fontSize: "12px",
                        position: "sticky",
                        left: "71px",
                        backgroundColor: "#fff",
                        zIndex: "98",
                      }}
                    >
                      {userData.client_name || ""}
                    </td>

                    <td
                      className="headersticky"
                      style={{
                        fontSize: "12px",
                        position: "sticky",
                        left: "122px",
                        backgroundColor: "#fff",
                        zIndex: "98",
                      }}
                    >
                      <button type="button">{userData.user_role}</button>
                    </td>
                    <td
                      className="headersticky"
                      style={{
                        fontSize: "12px",
                        position: "sticky",
                        left: "194px",
                        backgroundColor: "#fff",
                        zIndex: "98",
                      }}
                    >
                      {userData.loc_name || ""}
                    </td>
                    <td
                      className="headersticky sticky-right"
                      style={{
                        fontSize: "12px",
                        position: "sticky",
                        left: "260px",
                        backgroundColor: "#fff",
                        zIndex: "98",
                      }}
                    >
                      {userData.roster || ""}
                    </td>
                    {Array.from({ length: daysInRange }, (_, i) => {
                      const currentDay = new Date(startDateObj);
                      currentDay.setDate(startDateObj.getDate() + i);

                      const day = currentDay.getDate();
                      const month = currentDay.getMonth() + 1;
                      const year = currentDay.getFullYear();
                      const formattedDate = `${year}-${month
                        .toString()
                        .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

                      // Find data for this specific day in THIS roster's events
                      const dataForDay = userData.events.find((item) => {
                        const itemDate = moment(item.start).format(
                          "YYYY-MM-DD"
                        );
                        return itemDate === formattedDate;
                      });

                      if (dataForDay !== undefined) {
                        return (
                          <td
                            key={i}
                            style={{
                              backgroundColor: dataForDay.backgroundColor,
                              color: dataForDay.color,
                              fontSize: "12px",
                              width: "150px",
                            }}
                            className="shiftspace"
                          >
                            {dataForDay.shft === "Add" ? "RR" : dataForDay.shft}{" "}
                            <br />
                            {dataForDay.hours}
                            {dataForDay.shft !== "Add" &&
                            dataForDay.shft !== "Edit" &&
                            dataForDay.id !== undefined ? (
                              <div
                                className="shiftselect"
                                style={{
                                  width: "41px",
                                }}
                              >
                                <select
                                  className="w-100 mt-2"
                                  value={dataForDay.hours || ""}
                                >
                                  <option value={""}>Choose Hours</option>
                                  {numbers.map((number) => (
                                    <option key={number} value={number}>
                                      {number}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            ) : null}
                          </td>
                        );
                      } else {
                        return <td key={i}></td>;
                      }
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default CoverageRoster;
